import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { Redirect } from 'react-router'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'
import UserConfirmation from './UserConfirmation'
import ReactGA from 'react-ga';


class Signin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      modal: false,
      componentToShow: 'userNameComp',
      buttonDisable: false,
      validationErrors: {
        phoneNumberError: '',
        passwordError: '',
        otpError: ''
      },

      data:{
        userName: '',
        confirmOtp: '',
        password:'',
      },
      userInfo: {
        accessToken: '',
        client: '',
        uid: '',
        email: '',
        id: '',
        role: '',
        userName: '',
        image: '',
        phone: ''
      },
      formErrors:{
        userNameError: '',
        passwordError: '',
        otpError: '',
      },
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkForErrors = this.checkForErrors.bind(this)

  }


  componentDidMount() {
   ReactGA.initialize('UA-139837993-1');
   ReactGA.pageview('portal/signin'); 
  }

  checkForErrors(type){
  	
    let errorObj = Object.assign({}, this.state.formErrors)
    let error = false
    errorObj.passwordError =''
    errorObj.otpError =''

    if(type === 'password'){
      if(this.state.data.password === undefined || this.state.data.password === ''){
        error = true
        errorObj.passwordError = 'Password is Mandatory'
      }
    }

    if(type === 'confirmOtp'){
      if(this.state.data.confirmOtp === undefined || this.state.data.confirmOtp === ''){
        error = true
        errorObj.otpError = 'OTP is Mandatory'
      }
    }

    this.setState({formErrors: errorObj})
    return error;
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  checkForPwdReset = (e) => {
    e.preventDefault()
    let errorObj = Object.assign({}, this.state.formErrors)
    errorObj.userNameError = ''
    let validSucess = true
    if(this.state.data.userName === ''){
      errorObj.userNameError ='User Name is Mandatory'
      validSucess = false
    }

    if(validSucess){
      this.setState({buttonDisable:true})
      let apiInput = {
        'userName': this.state.data.userName
      }
      api.checkForResetPwdStatus(apiInput)
        .then((result) => {
          if(result.status ==='success'){
            let componentToShow
            if(result.pwd_change_reqd === 'yes')
              componentToShow = 'otpComponent'
            else 
              componentToShow = 'passwordComponent'  
            this.setState({componentToShow: componentToShow, formErrors: errorObj, buttonDisable:false})        
          }
                    
        }).catch((err) => {
        this.setState({ errorMsg: err.stack, buttonDisable:false })
      })
    }
    
    else{
      this.setState({formErrors:errorObj})
    }
    
  }

  handleSubmit(e) {
    e.preventDefault()
    const obj = {}
    const err = this.checkForErrors('password')

    if (!err) {
      this.setState({buttonDisable:true})
      let  values = {
        'user_name': this.state.data.userName,
        'password': this.state.data.password
      }

      api
        .signIn(values)
        .then((result) => {
          const { status, data } = result
          //console.log('Sign In result = '+JSON.stringify(result))
          if (status === 'error') {
            if (result.errors) {
              this.setState({ errorMsg: result.errors})
            } else {
              this.setState({ errorMsg: 'Please check your User Name & Password' })
            }
          }

          if (status === 'inactive') {
            if (result.errors) {
              this.setState({ errorMsg: result.errors})
            } else {
              //redirect to conform otp page
              this.setState({componentToShow: 'otpComponent'})
            }
          }

          if (status === 'success') {
          	//console.log('inside success')
            obj.accessToken = result.headers.accessToken            
            obj.userName = data.userName
            obj.role = data.role
            obj.id = data.id
            this.props.userLogin(obj)
            this.setState({signInSuccess: true})
            if(data.role === 'user') {
              if (this.props.match.params.typeName === 'learning_plan') {
                this.props.history.push('/portal/app/user/learning_resources')
              }
              else if (this.props.match.params.typeName === 'opportunity'){
                this.props.history.push('/portal/app/opportunities')
              }
              else if (this.props.match.params.typeName === 'certify'){
                this.props.history.push('/portal/app/user/about/tpo')
              }
              else if (this.props.match.params.typeName === 'tpo'){
                this.props.history.push('/portal/app/tpo_registration_details')
              }
              else if (this.props.match.params.typeName === 'questionnaires'){
                this.props.history.push('/portal/app/user/questionnaires')
              }
              else if (this.props.match.params.typeName === 'surveyhome'){
                this.props.history.push('/portal/app/user/survey_user_home')
              }
              else if (this.props.match.params.typeName === 'quizhome'){
                this.props.history.push('/portal/app/user/samplequiz_user_home')
              }
              else {
                
                if(data.pwdChangeReqd !== undefined && data.pwdChangeReqd === 'yes'){
                  this.props.history.push('/portal/app/password_reset')
                }
                else{
                  this.props.history.push('/portal/app/my_registrations')
                }
              }
            }
            else if(data.role === 'admin')
              this.props.history.push('/portal/app/tpo_reg_users')
            else if(data.role === 'reviewer')
              this.props.history.push('/portal/app/reviewer/fc_parent')
            else if(data.role === 'lr_admin')
              this.props.history.push('/portal/app/admin/learning_taxonomies')
            else if(data.role === 'institution_admin')
              this.props.history.push('/portal/app/instadmin/instgroupreport')
            else if(data.role === 'affiliate_partner')
              this.props.history.push('/portal/app/user/affiliate_partner/initiate_module')
            else if(data.role === 'hallticket_admin')
              this.props.history.push('/portal/app/admin/hallticket/details')
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Login. Please contact Admin', buttonDisable:false})
        })
    }
  }

  onRedirectPostLogin = (pwdChangeReqd) => {

    if(pwdChangeReqd !== undefined && pwdChangeReqd === 'yes'){
      this.props.history.push('/portal/app/password_reset')
    }
    else{
      this.props.history.push('/portal/app/my_registrations')
    }
    
  }

  render() {


    let userNameComponent
    let passwordComponent
    let otpComponent

    if(this.state.componentToShow === 'userNameComp'){
      userNameComponent =(<div>
          <GridCell>
            <FormField style={{width: '100%'}}>
              <div className="login_icon">
                <TextFieldIcon use="perm_identity"/>
              </div>
              <TextField fullwidth label="Username" autoComplete="off" onChange={this.onInputChange} name="userName" className='user_name' value={this.state.data.userName} />
            </FormField>
            
          </GridCell>
          
          <GridCell className='submit-button'>
            <FormField>
              <Button raised disable={this.state.buttonDisable} onClick={this.checkForPwdReset}>SUBMIT</Button>
            </FormField>
            <StatusMessage error_msg = {this.state.formErrors.userNameError}/>
            <Typography use="subtitle" tag="a" href="forgot_password" className="forgot-password-link">Did you forget your Username/Password?</Typography>
          </GridCell>
          <GridCell className='sign-up-link'>
            <Typography use="subheading2">Don't have an account? <Typography use="body1" tag="a" href="/portal/signup">Sign Up.</Typography></Typography>
          </GridCell>
          <GridCell className='sign-up-link'>
            <Typography use="subheading2"><Typography use="body1" tag="a" href="https://centa.org">CENTA Home Page</Typography></Typography>
          </GridCell>
        
        </div>
      )
    }


    if(this.state.componentToShow === 'passwordComponent'){
      passwordComponent =(<div>
          <GridCell>
            <FormField style={{width: '100%'}}>
              <div className="login_icon">
                <TextFieldIcon use="lock_outline"/>
              </div>
              <TextField fullwidth label="Password" type="password" name="password" className='password' onChange={this.onInputChange} value={this.state.data.password} />
            </FormField>
          </GridCell> 
          <GridCell className='submit-button'>
            <FormField>
              <Button raised disable={this.state.buttonDisable} onClick={this.handleSubmit}>SIGNIN</Button>
            </FormField>
            <StatusMessage error_msg = {this.state.formErrors.passwordError}/>
          </GridCell>
          <GridCell className='sign-up-link'>
            <Typography use="subheading2">Back to <Typography use="body1" tag="a" href="/portal/signin">Sign In</Typography></Typography>
          </GridCell>
        </div>
      )
    }

    if(this.state.componentToShow === 'otpComponent'){
      otpComponent =(
        <UserConfirmation userName={this.state.data.userName} onRedirectPostLogin={this.onRedirectPostLogin}/>
      )
    }

    return (
      <div>
        <Grid className="login-card">
          <GridCell span="4" align="middle"></GridCell>
          <GridCell className="align-center" span="4">
            <form >
              <Card style={{width: '21rem',padding: '25px'}}>
                <GridCell>
                  <div style={{padding: '0 1rem 1rem 1rem'}}>
                    <img src={centaLogo} alt="logo" />
                    <Typography use="title" tag="h2">Sign In</Typography>
                    <Typography
                      use="subheading1"
                      tag="h3"
                      theme="text-secondary-on-background"
                      style={{marginTop: '-1rem'}}
                    >
                    </Typography>
                  </div>
                </GridCell>
                  {userNameComponent}
                  {passwordComponent}
                  {otpComponent}
                  <StatusMessage error_msg = {this.state.errorMsg}/>
              </Card>
            </form>
            
          </GridCell>
          <GridCell span="4" align="middle"></GridCell>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin)




// WEBPACK FOOTER //
// ./src/views/Signin.jsx